export enum Colors {
  ERROR = '#D70000',
  BLACK = '#171718',
  WHITE = '#fff',
}
